import { createZustandStoreProvider } from '@/true-fsd/shared/utils/zustand';
import { WorkspaceType } from '@synapex/shared2/entities';
import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';
import { createStore, StoreApi } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type NewWorkspaceData = {
  newAccount: AdvertiserAccount.CreateInputDto;
  workspace_type: WorkspaceType;
};

const INITIAL_STATE: NewWorkspaceData = {
  newAccount: {
    name: '',
  },
  workspace_type: 'site',
};

type NewWorkspaceActions = {
  setNewAccount: (v: AdvertiserAccount.CreateInputDto) => void;
  setWorkspaceType: (v: WorkspaceType) => void;

  reset: () => void;
};

const createNewWorkspaceStore = (): StoreApi<
  NewWorkspaceData & NewWorkspaceActions
> =>
  createStore<NewWorkspaceData & NewWorkspaceActions>()(
    immer(
      persist(
        (set, _get, _store) => ({
          ...INITIAL_STATE,

          setNewAccount: (v: AdvertiserAccount.CreateInputDto) => {
            set((state) => {
              state.newAccount = v;
            });
          },

          setWorkspaceType: (v: WorkspaceType) => {
            set((state) => {
              state.workspace_type = v;
            });
          },

          reset: () => {
            set(INITIAL_STATE);
          },
        }),
        {
          name: `new-workspace`,
        },
      ),
    ),
  );

export const [
  NewWsStoreProvider,
  useNewWsStoreContext,
  useNewWsStoreIs,
  useNewWsStore,
] = createZustandStoreProvider(createNewWorkspaceStore);
